export const githubdark = {
    're code.hljs': {
        display: 'block',
        overflowX: 'auto',
        padding: '1em',
    },
    'ode.hljs': {
        padding: '3px 5px',
    },
    hljs: {
        color: '#c9d1d9',
        background: '#0d1117',
    },
    'hljs-doctag': {
        color: '#ff7b72',
    },
    'hljs-keyword': {
        color: '#ff7b72',
    },
    'hljs-meta .hljs-keyword': {
        color: '#ff7b72',
    },
    'hljs-template-tag': {
        color: '#ff7b72',
    },
    'hljs-template-variable': {
        color: '#ff7b72',
    },
    'hljs-type': {
        color: '#ff7b72',
    },
    'hljs-variable.language_': {
        color: '#ff7b72',
    },
    'hljs-title': {
        color: '#d2a8ff',
    },
    'hljs-title.class_': {
        color: '#d2a8ff',
    },
    'hljs-title.class_.inherited__': {
        color: '#d2a8ff',
    },
    'hljs-title.function_': {
        color: '#d2a8ff',
    },
    'hljs-attr': {
        color: '#79c0ff',
    },
    'hljs-attribute': {
        color: '#79c0ff',
    },
    'hljs-literal': {
        color: '#79c0ff',
    },
    'hljs-meta': {
        color: '#79c0ff',
    },
    'hljs-number': {
        color: '#79c0ff',
    },
    'hljs-operator': {
        color: '#79c0ff',
    },
    'hljs-variable': {
        color: '#79c0ff',
    },
    'hljs-selector-attr': {
        color: '#79c0ff',
    },
    'hljs-selector-class': {
        color: '#79c0ff',
    },
    'hljs-selector-id': {
        color: '#79c0ff',
    },
    'hljs-regexp': {
        color: '#a5d6ff',
    },
    'hljs-string': {
        color: '#a5d6ff',
    },
    'hljs-meta .hljs-string': {
        color: '#a5d6ff',
    },
    'hljs-built_in': {
        color: '#ffa657',
    },
    'hljs-symbol': {
        color: '#ffa657',
    },
    'hljs-comment': {
        color: '#8b949e',
    },
    'hljs-code': {
        color: '#8b949e',
    },
    'hljs-formula': {
        color: '#8b949e',
    },
    'hljs-name': {
        color: '#7ee787',
    },
    'hljs-quote': {
        color: '#7ee787',
    },
    'hljs-selector-tag': {
        color: '#7ee787',
    },
    'hljs-selector-pseudo': {
        color: '#7ee787',
    },
    'hljs-subst': {
        color: '#c9d1d9',
    },
    'hljs-section': {
        color: '#1f6feb',
        fontWeight: 'bold',
    },
    'hljs-bullet': {
        color: '#f2cc60',
    },
    'hljs-emphasis': {
        color: '#c9d1d9',
        fontStyle: 'italic',
    },
    'hljs-strong': {
        color: '#c9d1d9',
        fontWeight: 'bold',
    },
    'hljs-addition': {
        color: '#aff5b4',
        backgroundColor: '#033a16',
    },
    'hljs-deletion': {
        color: '#ffdcd7',
        backgroundColor: '#67060c',
    },
    'hljs-char.escape_': {},
    'hljs-link': {},
    'hljs-params': {},
    'hljs-property': {},
    'hljs-punctuation': {},
    'hljs-tag': {},
};
